/* eslint-disable unicorn/no-null */
import { Select } from '@mantine/core';
import {
    useIntegrationsQuery,
    useIntegrationConnectorIdnsQuery
} from '@/services/integration/integration.queries.ts';

interface IntegrationFieldsProps {
    integrationIdn: string | null;
    connectorIdn: string | null;
    onIntegrationChange: (value: string | null) => void;
    onConnectorChange: (value: string | null) => void;
    emptyIntegrationIdn?: string;
    errors?: Record<string, string>;
}

const EMPTY_INTEGRATION_IDN = '<current actor Integration>';

const IntegrationFields = ({
    integrationIdn,
    connectorIdn,
    onIntegrationChange,
    onConnectorChange,
    emptyIntegrationIdn = EMPTY_INTEGRATION_IDN,
    errors
}: IntegrationFieldsProps) => {
    const { data: integrations } = useIntegrationsQuery();
    const { data: connectorIdns = [] } = useIntegrationConnectorIdnsQuery(
        integrationIdn ?? ''
    );

    const integrationIdns = (integrations ?? []).map(
        (integration) => integration.idn
    );

    const handleIntegrationClear = () => {
        onIntegrationChange(null);
        onConnectorChange(null);
    };

    const handleIntegrationChange = (value: string | null) => {
        if (value === emptyIntegrationIdn) {
            onIntegrationChange(null);
            return;
        }
        onIntegrationChange(value);
    };

    const handleConnectorClear = () => {
        onConnectorChange(null);
    };

    const IntegrationOptions = [emptyIntegrationIdn, ...integrationIdns];

    return (
        <>
            <Select
                clearable
                clearButtonProps={{ onClick: handleIntegrationClear }}
                comboboxProps={{ withinPortal: false }}
                data={IntegrationOptions}
                error={errors?.integration_idn}
                label="Integration"
                name="integration_idn"
                placeholder={emptyIntegrationIdn}
                scrollAreaProps={{ type: 'always' }}
                value={integrationIdn ?? emptyIntegrationIdn}
                onChange={handleIntegrationChange}
            />
            <Select
                clearable
                clearButtonProps={{ onClick: handleConnectorClear }}
                comboboxProps={{ withinPortal: false }}
                data={connectorIdns}
                disabled={!integrationIdn}
                error={errors?.connector_idn}
                label="Connector"
                name="connector_idn"
                scrollAreaProps={{ type: 'always' }}
                value={connectorIdn}
                onChange={onConnectorChange}
            />
        </>
    );
};

export default IntegrationFields;
